import { ReportSource } from '@/features/Reports/interfaces';

import { getMediaResolutionPipeline } from '../di/createMediaResolutionContainer';
import {
  attachResolvedMediaToSource,
  buildMediaResolutionInput,
  sourceNeedsMediaResolution,
} from './sourceMediaInputs';

export const resolveReportSourceMedia = async (source: ReportSource): Promise<ReportSource> => {
  if (!sourceNeedsMediaResolution(source)) {
    return source;
  }

  const input = buildMediaResolutionInput(source);

  if (!input) {
    return source;
  }

  const pipeline = getMediaResolutionPipeline();
  const result = await pipeline.resolve(input);

  return attachResolvedMediaToSource(source, result.media);
};

export const resolveReportSourcesMedia = async (
  sources: Array<ReportSource>
): Promise<Array<ReportSource>> =>
  Promise.all(sources.map(source => resolveReportSourceMedia(source)));
